import { classnames } from 'Utils/classnames/classnames.utils';
import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { ImmersiveSlideShow } from 'Components/widgets/immersive-slideshow/ImmersiveSlideShow';
import type {
  MultimediaLabels,
  MultimediaResources,
} from 'Components/widgets/multimedia/Multimedia';
import { Multimedia } from 'Components/widgets/multimedia/Multimedia';
import { heights } from 'Components/widgets/navigation/Navigation.constants';
import { useAppContext } from 'Context/ReactAppContext';
import { ProductImmersiveNarrow } from './product-immersive-narrow/ProductImmersiveNarrow';
type Props = {
  className?: string;
  closeLabel?: string;
  galleryLabel?: string;
  id?: string;
  media: Array<string>;
  multimedia: MultimediaResources;
  multimediaLabels: MultimediaLabels;
  nextLabel?: string;
  openGalleryLabel?: string;
  pictureAltLabel?: string;
  previousLabel?: string;
  size?: ImmersiveSizeProps;
};
export const ProductImmersive = ({
  className,
  closeLabel,
  galleryLabel,
  id,
  media = [],
  multimedia,
  multimediaLabels,
  nextLabel,
  openGalleryLabel,
  pictureAltLabel,
  previousLabel,
  size = 'large',
}: Props) => {
  const { isDesktop } = useResponsive();
  const appContext = useAppContext();

  if (!media.length) {
    return null;
  }

  const multimediaStyle = isDesktop
    ? {
        bottom: '45px',
      }
    : {
        bottom: '80px',
      };
  return (
    <div
      className={classnames('relative', className)}
      style={
        appContext.isSeller
          ? {
              top: `-${heights.NAVIGATION_LARGE_HEIGHT}px`,
            }
          : {}
      }
      data-testid="immersive"
      {...(id
        ? {
            id,
          }
        : null)}
    >
      {isDesktop ? (
        <ImmersiveSlideShow
          immersiveSize={size}
          media={media}
          nextLabel={nextLabel}
          pictureAltLabel={pictureAltLabel}
          previousLabel={previousLabel}
        />
      ) : (
        <ProductImmersiveNarrow
          media={media}
          nextLabel={nextLabel}
          pictureAltLabel={pictureAltLabel}
          previousLabel={previousLabel}
          size={size}
        />
      )}
      <div className="absolute ms-20 lg:mx-0 lg:w-full" style={multimediaStyle}>
        <Multimedia
          closeLabel={closeLabel}
          galleryLabel={galleryLabel}
          isOverlay
          labels={multimediaLabels}
          medias={multimedia}
          nextLabel={nextLabel}
          openGalleryLabel={openGalleryLabel}
          pictureAltLabel={pictureAltLabel}
          previousLabel={previousLabel}
          theme={isDesktop ? 'overlay' : 'overlayCompact'}
        />
      </div>
    </div>
  );
};
